

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import store from './store'
import App from './App'
import Promotion from './components/Promotion'
import PromotionUsers from './components/PromotionUsers'
import XHeader from 'vux/src/components/x-header/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import VueScroller from 'vue-scroller'

Vue.component('x-header', XHeader)
Vue.use(VueRouter)
Vue.use(VueScroller)
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)

const routes = [
{
name: 'Promotion',
path: '/promotion',
component: Promotion,
meta: { title: '魔猴网 - 活动' }
},
{
name: 'PromotionUsers',
path: '/promotion_users',
component: PromotionUsers,
meta: { title: '魔猴网 - 活动参加者' }
}
]

const router = new VueRouter({
routes
})

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js